module.exports = __webpack_public_path__ + "img/0Q3A7692_L_Foamcore.e5ae1c42.jpg";